import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  ICustomer,
  IProfileEntity,
  IProfileEntityDetail,
} from '@boma/supplier-portal/shared/entities';
import { CustomersService } from '@boma/supplier-portal/shared/services';
import { getSelectedOrganizationInfo } from '@boma/supplier-portal/shared/state';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { debounceTime, take } from 'rxjs/operators';

@Component({
  selector: 'boma-customer-selector',
  templateUrl: './boma-customer-selector.component.html',
  styleUrls: ['./boma-customer-selector.component.scss'],
})
export class BomaCustomerSelectorComponent implements OnInit {
  // To prevent errors on pages that currently use this
  @Input() legacy = true;
  @Input() showLabels = true;
  @Input() customerLabel = 'Customer';
  @Input() singleSelection = true;
  @Input() initialCustomers: ICustomer[];
  @Input() placeHolderText = 'All Customers';
  @Input() showTypes = false;
  @Input() searchTarget: 'Customer' | 'Vendor' = 'Customer';
  @Output() selectedItemsChange = new EventEmitter();
  @Output() customerTypeChange = new EventEmitter();

  filterText: string = '';
  customerLock = false;
  loadingText: string = 'Searching for: ' + this.filterText;
  customers: ICustomer[];
  selectedCustomers: ICustomer[];
  selectedCustomer: ICustomer;
  selectedOrganizationId$: Observable<string>;
  selectedOrganisation: IProfileEntity;
  searchedCustomers = false;

  perPage = '25'; //TODO Grab Less Customers & implement search rather than filter
  page = '1';

  searching: Subject<boolean> = new Subject<boolean>();

  customerTypes = ['All', 'Registered', 'Unregistered'];

  selectedType = 'All';

  private searchSubject = new Subject<string>();

  constructor(
    private customersService: CustomersService,
    private store: Store
  ) {
    this.searchSubject.pipe(debounceTime(500)).subscribe((query: string) => {
      this.searchCustomers(query);
    });
  }

  ngOnInit(): void {
    if (this.initialCustomers && !Array.isArray(this.initialCustomers)) {
      this.initialCustomers = [this.initialCustomers];
      this.customerLock = true;
    }

    this.customers = this.initialCustomers ?? [];
    this.selectedCustomers = this.initialCustomers ?? [];

    this.store
      .select(getSelectedOrganizationInfo)
      .pipe(take(1))
      .subscribe((org) => {
        if (org) {
          this.selectedOrganisation = org as IProfileEntityDetail;
        }
      });
  }

  showPanel() {
    console.log(this.customers, this.customers?.length, this.searchedCustomers);

    if (!this.customers || !this.customers?.length || !this.searchedCustomers)
      this.onSearch('');
  }

  //TODO STORE IN STATE

  searchCustomers(ev = '') {
    this.searching.next(true);
    this.searchedCustomers = true;
    this.customersService
      .loadCustomers({
        entityId: this.selectedOrganisation.id,
        query: ev || '',
        page: this.page,
        perPage: this.perPage,
        customerType: this.selectedType,
        searchTarget: this.searchTarget
      })
      .subscribe((r) => {
        r.items.forEach((response) => {
          const nameIncludesFilter = response.name.includes(this.filterText);
          if (!nameIncludesFilter) {
            this.searching.next(nameIncludesFilter);
          }
        });
        const response = r.items.map((i) => {
          if (!i.name.trim()) {
            i.name = i.contactNumber || 'Anonymous';
          }
          return i;
        });
        // We merge the so we dont end up with any empty tags in the dropdown field

        const mergedArray = [...response, ...this.customers];
        // Remove duplicates based on the 'id' property
        this.customers = mergedArray.reduce((acc, current) => {
          const x = acc.find((item) => item.id === current.id);
          if (!x) {
            return acc.concat([current]);
          } else {
            return acc;
          }
        }, []);

        if (this.filterText && this.filterText.length > 0) {
          const originalFilter = this.filterText;
          this.filterText = this.filterText.slice(0, -1);
          //Set a timeout so that we fool the silly computer
          setTimeout(() => {
            this.filterText = originalFilter;
          }, 10);
        }

        this.searching.subscribe((value) => {
          if (value === true) {
            this.loadingText = 'Searching for: ' + this.filterText;
          } else {
            setTimeout(() => {
              this.loadingText = 'There are no results for: ' + this.filterText;
            }, 1000);
          }
        });
      });
    this.searching.next(false);
  }

  // Call this method whenever you want to trigger a search
  onSearch(ev: string) {
    this.filterText = ev;
    this.searchSubject.next(ev);
  }

  updateCustomerType(ev) {
    console.log(ev);
    this.customerTypeChange.emit(this.selectedType);
    this.customers = [];
    this.onSearch('');
  }

  clearSelection() {
    this.selectedCustomers = [];
    this.selectedItemsChange.emit(this.selectedCustomers);
  }

  handleCustomerSelection(ev) {
    console.log(ev);
    this.selectedCustomer = Array.isArray(ev.value) ? null : ev.value;
    this.selectedCustomers = Array.isArray(ev.value) ? ev.value : [ev.value];
    this.selectedItemsChange.emit(this.selectedCustomers);
  }
}
